import { RequestService } from '@/api/services/request.service';
import { DEFAULT_META_DATA } from '@/constants/common';
import { Metadata } from '@/types/metadata';
import { mapRewriteUrlToDestination } from '@/utils/url';

export const getMetadata = async (
	pageUrl: string = '',
	fallbackMetadata: Metadata = DEFAULT_META_DATA,
): Promise<Metadata> => {
	const request = RequestService.getInstance();
	const newMetaData = { ...fallbackMetadata };
	const metadataPageUrl = mapRewriteUrlToDestination(pageUrl);

	try {
		const { data } = await request.get<Metadata>('/api_v1/page-metadata/', {
			params: { url: metadataPageUrl },
		});

		Object.keys(data).forEach((key) => {
			if (data[key] !== '') {
				newMetaData[key] = data[key];
			}
		});

		return newMetaData;
	} catch (err) {
		if (err?.response?.status !== 404) console.log(err);
		return newMetaData;
	}
};
